 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons"  :style="{position: button_position}">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20 search" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">手机：</span>
                <el-input v-model="mobile" placeholder="手机模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">用户类型：</span>
                <el-select
                    clearable
                    class="status" v-model="role_type" placeholder="请选择用户类型" style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="allPutMessage">群发</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="role_type" label="用户类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_count" label="消息数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_date" label="最新消息时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">发送
                </el-button>
                <el-button :id="'doctorEdit'" @click="goUserList(scope.row)"
                           type="text" size="mini">查看消息
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allRole: [
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                    // {
                    //     id: 5,
                    //     name: '健康管理助理'
                    // },
                ],
                user_name: '',
                mobile: '',
                role_type: '',
                button_position: 'absolute',
                is_mobile: false,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
        },
        mounted() {
            // 获取列表
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'system_message_add' || prev_page == 'system_message_user_list') {
                this.user_name = localStorage.getItem('system_message_user_name')
                this.mobile = localStorage.getItem('system_message_mobile')
                this.role_type = localStorage.getItem('system_message_role_type')
                if (this.mobile == 'undefined' || this.mobile == 'null') {
                    this.mobile = ''
                }
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.role_type == 'undefined' || this.role_type == 'null') {
                    this.role_type = ''
                }
                if (this.role_type) {
                    this.role_type = parseInt(this.role_type)
                }
            }
            this.getList();
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'getMessageUser',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        role_type: this.role_type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].role_type) {
                            case '1':
                                res.data.data.list[i].role_type = '特属服务对象';
                                res.data.data.list[i].role_type_number = 1;
                                break;
                            case '3':
                                res.data.data.list[i].role_type = '特属专家';
                                res.data.data.list[i].role_type_number = 3;
                                break;
                            case '5':
                                res.data.data.list[i].role_type = '健康管理助理';
                                res.data.data.list[i].role_type_number = 5;
                                break;
                        }
                    }
                    localStorage.setItem('system_message_user_name', this.user_name)
                    localStorage.setItem('system_message_mobile', this.mobile)
                    localStorage.setItem('system_message_role_type', this.role_type)
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    localStorage.setItem('prev_page', 'system_message_list')
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.mobile = "";
                this.role_type = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "systemMessageAdd", params: {
                        user_id: data.user_id,
                        type: 1
                    }
                });
            },

            goUserList(data) {
                this.$router.push({
                    name: "systemMessageUserList", params: {
                        user_id: data.user_id,
                        user_name: data.user_name,
                    }
                });
            },

            // 导出数据
            allPutMessage() {
                this.$router.push({
                    name: "systemMessageAdd", params: {
                        type: 2
                    }
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
    .search .el-input {
        width: 100% !important;
    }
</style>
